export default "__VITE_ASSET__BSk8Qm9k__"